import React from "react";
import { Field, ConfigInput } from "./Field";

export default function ZapierFields({ config, setConfig }) {
  return (
    <Field label="Zapier / Make webhook URL" required colSpan={2}
      hint={<>
        Zapier: <b>Create Zap → Webhook (Catch Hook)</b>, copy the URL.
        Make.com: <b>Custom webhook</b> module → copy URL.
        We&apos;ll POST the full lead payload — no auth needed (the URL itself is the secret).
      </>}>
      <ConfigInput name="url" config={config} setConfig={setConfig}
        testId="dest-zapier-url" required className="text-xs"
        placeholder="https://hooks.zapier.com/hooks/catch/... OR https://hook.us1.make.com/..." />
    </Field>
  );
}
